module.exports = __webpack_public_path__ + "static/media/step-name-es.ed11cd59.png";